import { FC, ReactNode } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface MediaCardProps {
  alt: string;
  title: string;
  description: string;
  // Use src or img, not both, src is for links, img is for local images
  src?: string;
  img?: ReactNode;
  actions?: ReactNode;
  onClick?: () => void;
}

export const MediaCard: FC<MediaCardProps> = ({ src, img, alt, title, description, actions, onClick }) => {
  return (
    <Card
      onClick={onClick}
      elevation={0}
      sx={(theme) => ({
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'scale 0.1s ease-in-out',
        '&:hover': onClick ? {
          scale: 1.02,
        } : {},
      })}
    >
      {img && (
        <Box 
          sx={{ 
            p: 10,
            height: 300,
            width: '100%',
            overflow: 'hidden',
            position: 'relative',
            '& > svg': {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              minWidth: '100%',
              minHeight: '100%',
            }
          }}
        >
          {img}
        </Box>
      )}
      {src && (
        <Box
          sx={{
            height: 300,
            width: '100%',
            overflow: 'hidden',
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CardMedia 
            sx={{ 
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              objectPosition: 'center',
            }} 
            component="img"
            image={src} 
            title={alt} 
          />
        </Box>
      )}
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      </CardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
};

export default MediaCard;
